import React from 'react';
import { contentRoot } from '../config.js';
import localization from '../helpers/localization.js';

let selectedIndicatorStyle={
   
   position:"absolute",
   left:0,
   top:0,
   display:"inline",
   width: "100%",
   height: "100%",
   border: "green",
   borderStyle: "solid",
    borderWidth:"thick"
};


let isSelected = function(material,selected)
{
    if(material && selected)
    {
    return material.id === selected;
    }
    else
    {
      return false;
    }
};
const materialOption = (props) => {
    let itemStyle = {};
    let materialThumbNailStyle =
    {
        position: "relative",
        display: "inline",
        top: 0,
        left: 0,
        width: "100%"
    };
    if (props.mirrored) {
        materialThumbNailStyle.transform ="scaleX(-1)"
    }
    if (props.itemWidth) {
        itemStyle.width = props.itemWidth + "%";
        itemStyle.fontSize = props.itemWidth * 0.9 + "px";
        itemStyle.flex_basis = props.itemWidth + "%";
    }

    return (<div className="materialOption" style={itemStyle} key={props.material.id} onClick={() => { props.onChange(props.material); }}>
        <img  style={materialThumbNailStyle} src={contentRoot + props.material.thumbnail || "img/materials/tervaleppa.jpg"} alt={props.material.name}></img>
        {isSelected(props.material, props.selected) && <span><div style={selectedIndicatorStyle}></div><div className="selectedText" >✓ {localization.selected}</div></span>}
    </div>);
}

export default materialOption;    